import { Profiles } from 'types/user';

export enum EDDR_MODULES {
  EDDR_OVERVIEW = 'EDDR_OVERVIEW',
  EDDR_PROGRESS_CURVE = 'EDDR_PROGRESS_CURVE',
  EDDR_OPERATIONS_LOG = 'EDDR_OPERATIONS_LOG',
  EDDR_OPERATIONS_CURVES = 'EDDR_OPERATIONS_CURVES',
  EDDR_FLUIDS = 'EDDR_FLUIDS',
  EDDR_BHA = 'EDDR_BHA',
  EDDR_TRAJECTORY = 'EDDR_TRAJECTORY',
  EDDR_SAFETY = 'EDDR_SAFETY',
  EDDR_WELL_ACTIVITY_HISTORY = 'EDDR_WELL_ACTIVITY_HISTORY',
}

export const eddrModules = Object.values(EDDR_MODULES);

export const eddrModulesAllowedForReportingPartner = Object.values(EDDR_MODULES).filter(
  module => module !== EDDR_MODULES.EDDR_OPERATIONS_CURVES,
);

export const allowedEddrModules = {
  [Profiles.NO_ACCESS]: [] as EDDR_MODULES[],
  [Profiles.PO]: eddrModules,
  [Profiles.DRILLX]: eddrModules,
  [Profiles.INTERNAL]: eddrModules,
  [Profiles.EXTERNAL]: eddrModules,
  [Profiles.REPORTING_PARTNER]: eddrModulesAllowedForReportingPartner,
  [Profiles.REPORTING_PARTNER_WITH_COSTS]: eddrModulesAllowedForReportingPartner,
};
